(function() {

    document.addEventListener('DOMContentLoaded', function() {
        const formData = {
            action: 'callme_form_controller_nonce_action'
        } 
        const queryString = new URLSearchParams(formData).toString();
        fetch(wpajax.ajaxurl + '?' + queryString, {
            method: 'GET'
        })
        .then(response => response.json())
        .then(response => { 
            if ( response.success ) {
                document.querySelectorAll('.shared-block-callme-form').forEach(block => {
                    block.querySelector('input[name="wpnonce"]').value = response.data.nonce;
                });
            }
        });
    });
    



    document.querySelectorAll('.shared-block-callme-form').forEach(block => {
        const form = block.querySelector('form');
        form.addEventListener('submit', async (e) => {            
            e.preventDefault();
            
            const formError = form.querySelector('.form-error');
            formError.style.display = 'none';
            
            document.dispatchEvent(new CustomEvent(window.AseguraGoConstants.ASEGURAGO_SHOW_LOADER_EVENT, {}));

            const formData = new FormData(form);

            if ( !phoneNumberValidator(formData) ) {     
                formError.innerText = 'El número de teléfono no es válido.';
                formError.style.display = 'block';
                document.dispatchEvent(new CustomEvent(window.AseguraGoConstants.ASEGURAGO_HIDE_LOADER_EVENT, {}));
                return;
            }

            const formDataPrepared = await prepareExtraFields(formData, form);

            fetch(wpajax.ajaxurl, {
                method: 'POST',
                body: formDataPrepared
            })
            .then(response => response.json())
            .then(data => {                
                if (data.success) {
                    const jsonDataPrepared = Object.fromEntries(formDataPrepared.entries());
                    jsonDataPrepared.typeEventData = 'lead';

                    document.dispatchEvent(new CustomEvent(window.AseguraGoConstants.ASEGURAGO_CALLME_FORM_SUBMITED_EVENT, {
                        detail: jsonDataPrepared
                    }));   
                    
                    document.dispatchEvent(new CustomEvent(window.MetricsManagerUserDataConstants.METRICS_USERDATA_EVENT_SEND_DATALAYER, {
                        detail: jsonDataPrepared
                    }));
                }
                document.dispatchEvent(new CustomEvent(window.AseguraGoConstants.ASEGURAGO_HIDE_LOADER_EVENT, {}));
            })
            .catch(error => {
                document.dispatchEvent(new CustomEvent(window.AseguraGoConstants.ASEGURAGO_HIDE_LOADER_EVENT, {}));
                formError.innerText = 'No se ha podido enviar la solicitud.';
                formError.style.display = 'block';
            });            

        });
    });


    async function prepareExtraFields(formData, form) {

        const aseguraGoAnalytics = new window.AseguraGoAnalytics();
        
        let email = formData.get('EMAIL') ? formData.get('EMAIL') : '';
        let hashedEmail = '';

        let phone = formData.get('PHONE') ? formData.get('PHONE') : '';
        let hashedPhone = '';
        if ( phone != '' ) {
            phone = window.AseguraGoConstants.PHONE_PREFIX + phone;
            hashedPhone = await aseguraGoAnalytics.generateHash(phone);
        }

        if ( email != '' ) {
            hashedEmail = await aseguraGoAnalytics.generateHash(email);
        }

        let hashedId = ( email != '' ) ? hashedEmail : hashedPhone;

        formData.set("PHONE", phone);
        formData.set("phone", phone);
        formData.set("hashedPhone", hashedPhone);
        formData.set("email", email);
        formData.set("hashedEmail", hashedEmail);
        formData.set("userId", hashedId);
        formData.set("hashedId", hashedId);
        if ( aseguraGoAnalytics.getUtmSource() ) formData.set("utmSource", aseguraGoAnalytics.getUtmSource());
        if ( aseguraGoAnalytics.getUtmMedium() ) formData.set("utmMedium", aseguraGoAnalytics.getUtmMedium());
        if ( aseguraGoAnalytics.getUtmCampaign() ) formData.set("utmCampaign", aseguraGoAnalytics.getUtmCampaign());
        if ( aseguraGoAnalytics.getUtmContent() ) formData.set("utmContent", aseguraGoAnalytics.getUtmContent());
        if ( aseguraGoAnalytics.getUtmTerm() ) formData.set("utmTerm", aseguraGoAnalytics.getUtmTerm());
        formData.set("leadId", aseguraGoAnalytics.generateLeadId());
        formData.set("pageUrl", aseguraGoAnalytics.getUrlUtmsCalculated());

        return formData;

    }




    function phoneNumberValidator(formData) {

        const phone = formData.get('PHONE');

        if ( !phone ) {
            return true;
        }

        const phonePreparedAsArray = phone.match(/\d/g)
        if (!phonePreparedAsArray) {
            return false;
        }
        
        if (phonePreparedAsArray.length !== 9) {
            return false;
        }
    
        if (phonePreparedAsArray[0] !== '6' && phonePreparedAsArray[0] !== '7' && phonePreparedAsArray[0] !== '8') {
            return false;
        }
    
        return true;
    }

})();